import { createSelector } from "reselect";

import { IMyzTokenUserState } from "./MyzTokenUser";
import { ISubscriptionEmailState } from "./SubscriptionEmail";
import { GlobalState } from "./rootReducer";
import { WotdFormData } from "../../beans/api";

const subscriptionEmailDomain = (state: GlobalState): ISubscriptionEmailState =>
  state.subscriptionemail;
const myzTokenUserDomain = (state: GlobalState): IMyzTokenUserState =>
  state.myztokenuser;

export const canUseMyzToken = createSelector(
  [subscriptionEmailDomain, myzTokenUserDomain],
  (subscriptionemail, myztokenuser): boolean =>
    !!(
      subscriptionemail.email &&
      myztokenuser.data?.loginId &&
      subscriptionemail.email === myztokenuser.data?.loginId
    ),
);

export const wotdFormData = (state: GlobalState): WotdFormData =>
  state.wotdformdata.wotdFormData;
